<app-tab-generic 
[componentsData]="componentsData"
></app-tab-generic>
<!-- <app-main-crud [TableName]="TableName" [filterBy]="filters" [attributes]="attributes" [tableList]="tableList" [tableRelations]="tableRelations"  [optionsDropdown]="optionsMenu"></app-main-crud> -->
